import '../Authorization.css';
import React, {useState} from 'react';
import {isIsraeliIdChecksumValid, isIsraeliIdFormatValid, isValidPhoneNumber} from "../utils/verifyInputs";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faEye, faEyeSlash} from '@fortawesome/free-solid-svg-icons';
import {useLanguage} from "../LanguageContext";
import {getTranslation} from "../consts/translations";


interface LoginProps {
    inputId: string,
    setInputId: (id: string) => void,
    inputPhone: string,
    setInputPhone: (phone: string) => void,
    onSendCode: () => void,
    loading: boolean;
    setShowVerification: (showVerification: boolean) => void,
    verificationError: string,
    setVerificationError: (error: string) => void,
}


const Login: React.FC<LoginProps> = (props: LoginProps) => {
    const [idVisible, setIdVisible] = useState(false);
    const [idValid, setIdValid] = useState(false);
    const [phoneValid, setPhoneValid] = useState(false);
    const {language} = useLanguage();
    const translation = getTranslation(language);

    const handleIdInputChange = (e: any) => {
        props.setInputId(e.target.value);
        console.log("set input id to: ", e.target.value);
        if (!isIsraeliIdFormatValid(e.target.value)) {
            setIdValid(false);
        } else if (!isIsraeliIdChecksumValid(e.target.value)) {
            setIdValid(false);
        } else {
            setIdValid(true);
        }
    }


    const handleIdInputBlur = () => {
        if (!isIsraeliIdFormatValid(props.inputId)) {
            props.setVerificationError(translation.invalid_israeli_id_length_error_message);
            setIdValid(false);
        } else if (!isIsraeliIdChecksumValid(props.inputId)) {
            props.setVerificationError(translation.invalid_israeli_id_error_message);
            setIdValid(false);
        } else {
            props.setVerificationError('');
            setIdValid(true);
        }
    }

    const handlePhoneNumberInputChange = (e: any) => {
        props.setInputPhone(e.target.value);
        const validPhoneNumber = isValidPhoneNumber(e.target.value);

        if (!validPhoneNumber) {
            setPhoneValid(false);
        } else {
            setPhoneValid(true);
        }
    }

    const handlePhoneNumberInputBlur = () => {
        const value = props.inputPhone;
        const validPhoneNumber = isValidPhoneNumber(value);

        if (!validPhoneNumber) {
            props.setVerificationError(translation.invalid_phone_number_error_message);
            setPhoneValid(false);
        } else {
            props.setVerificationError("");
            setPhoneValid(true);
        }
    }

    return (
        <div className="login-container">
            <div className="login-description">
                {translation.login_description}
            </div>
            <div className="login-input-container">
                <input className="login-input"
                       placeholder={translation.login_id_placeholder}
                       onChange={handleIdInputChange}
                       onBlur={handleIdInputBlur}
                       type={
                           idVisible ? "text" : "password"
                       }
                       value={props.inputId}
                ></input>
                <FontAwesomeIcon className="eye-icon"
                                 icon={idVisible ? faEyeSlash : faEye}
                                 onClick={() => setIdVisible(!idVisible)}
                />
            </div>
            <input className="login-input"
                   placeholder={translation.login_phone_placeholder}
                   onChange={handlePhoneNumberInputChange}
                   onBlur={handlePhoneNumberInputBlur}
                   value={props.inputPhone}
            ></input>
            <button
                className={`login-button ${props.loading ? "loading" : ""}`}
                disabled={props.loading || (!idValid || !phoneValid)}
                onClick={props.onSendCode}>
                {props.loading ? "" : translation.login_get_code_button_text}
            </button>
            <div className="login-verification-error">
                {props.verificationError}
            </div>
        </div>
    )
}

export default Login;
